// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3Xlr3","upload":"Small_upload__dKZkv","imageWrap":"Small_imageWrap__32vDs","removeBtn":"Small_removeBtn__1tg7r"};